// Get the current locale
const locale = document.documentElement.lang;

/* Submit a string of text and have it translated to the current locale */
export function __(text) {
  if (locale == 'en') {
    return text;
  }
  return TRANSLATION[locale][text] || text;
}

const TRANSLATION = {
  es: {
    'All time': 'Total',
    'Total': 'Total',
    'Cases': 'Casos',
    'cases': 'casos',
    'Deaths': 'Muertes',
    'Confirmed cases': 'Casos confirmados',
    'confirmed cases': 'casos confirmados',
    'confirmed case': 'caso confirmado',
    'deaths': 'muertes',
    'death': 'muerte',
    'Stay-at-home order': 'Orden de permanecer en casa',
    'Governor': 'Gobernador',
    'eases limits': 'reduce límites',
    'Date': 'Fecha',
    'State': 'Estado',
    'per 100,000': 'por 100,000',
    'Per 100k': 'Por 100k',
    'Last 14 days': 'Últimos 14 días',
    'New cases': 'Nuevos casos',
    'New deaths': 'Nuevas muertes',
    'New <span class="cases-blue">cases</span> by day':
      'Nuevos <span class="cases-blue">casos</span> por día ',
    '<span class="deaths-gray">Deaths</span> by day':
      '<span class="deaths-gray">Muertes</span> por día',
    'Show all': 'Mostrar todo',
    'Show less': 'Mostrar menos',
    'Updated': 'Actualizada',
    'Fewer': 'Menos',
    'More': 'Más',
    'Race': 'Grupo',
    'Deaths Pct.': 'Porcentaje de muertes',
    'Population Pct.': 'Porcentaje de población',
    'Totals': 'Totales',
    'Metric': 'Métrica',
    'Method': 'Método',
    'Per 100,000 residents': 'Por cada 100,000 personas',
    'Grand totals': 'Totales',
    'ICU': 'UCI',
    "Available <span class='cases-blue'>ICU beds</span>":
      "Camas <span class='cases-blue'>disponibles en Unidades de Cuidado Intensivo</span>",
    '<a href="https://data.ca.gov/dataset/covid-19-hospital-data">California Department of Public Health</a>':
      '<a href="https://data.ca.gov/dataset/covid-19-hospital-data">Departamento de Salud Pública de California</a>',
    '<a href="https://www.cdph.ca.gov/Programs/CID/DCDC/Pages/COVID-19/COVID-Variants.aspx">California Department of Public Health</a>':
      '<a href="https://www.cdph.ca.gov/Programs/CID/DCDC/Pages/COVID-19/COVID-Variants.aspx">Departamento de Salud Pública de California</a>',
    '<a href="https://data.ca.gov/dataset/covid-19-vaccine-progress-dashboard-data">California Department of Public Health</a>':
      '<a href="https://data.ca.gov/dataset/covid-19-vaccine-progress-dashboard-data">Departamento de Salud Pública de California</a>',
    "Positive <span class='cases-blue'>test</span> rate, seven-day average":
      "Tasa de <span class='cases-blue'>prueba positiva</span>",
    "New <span class='cases-blue'>tests</span> by day":
      "Nuevas <span class='cases-blue'>pruebas</span> por día",
    'California Department of Public Health':
      'Departamento de Salud Pública de California',
    'County': 'Condado',
    'Sunday': 'domingo',
    'Monday': 'lunes',
    'Tuesday': 'martes',
    'Wednesday': 'miércoles',
    'Thursday': 'jueves',
    'Friday': 'viernes',
    'Saturday': 'sábado',
    'Sunday': 'domingo',
    'Today': 'Hoy',
    'Cumulative cases by day': 'Casos acumulados por día',
    'Cumulative deaths by day': 'Muertes acumulados por día',
    'Search by name': 'Buscar por nombre',
    'Area': 'Área',
    'Filter by county': 'Filtrar por condado',
    'Confirmed patients': 'Pacientes confirmados',
    'Other': 'Otros',
    'Bay Area': 'Área de la Bahía',
    'Greater Sacramento': 'Región de Sacramento',
    'Northern California': 'Norte de California',
    'San Joaquin Valley': 'Valle de San Joaquín',
    'Southern California': 'Sur de California',
    'Active Cases': 'Casos activos',
    "Cumulative <span class='cases-blue'>cases</span>":
      "<span class='cases-blue'>Casos</span> acumulados",
    "Cumulative <span class='deaths-gray'>deaths</span>":
      "<span class='deaths-gray'>Muertes</span> acumulados",
    'Cumulative <span class="cum-cases-underline">cases</span>':
      '<span class="cum-cases-underline">Casos</span> acumulados',
    'Cumulative <span class="deaths-underline">deaths</span>':
      '<span class="deaths-underline">Muertes</span> acumulados',
    'Regions ranked by new <span class="new-cases-underline">cases</span> per 100,000 residents':
      'Regiones por orden de nuevos <span class="new-cases-underline">casos</span> por cada 100,000 personas',
    'Regions ranked by new <span class="new-cases-underline">cases</span>':
      'Regiones por orden de nuevos <span class="new-cases-underline">casos</span>',
    'Regions ranked by <span class="deaths-underline">deaths</span>':
      'Regiones por orden de <span class="deaths-underline">muertes</span>',
    'Regions ranked by <span class="deaths-underline">deaths</span> per 100,000 residents':
      'Regiones por orden de <span class="deaths-underline">muertes</span> por cada 100,000 personas',
    'Counties ranked by new <span class="new-cases-underline">cases</span> per 100,000 residents':
      'Condados por orden de nuevos <span class="new-cases-underline">casos</span> por cada 100,000 personas',
    'Counties ranked by <span class="deaths-underline">deaths</span> per 100,000 residents':
      'Condados por orden de <span class="deaths-underline">muertes</span> por cada 100,000 personas',
    'Counties ranked by <span class="deaths-underline">deaths</span>':
      'Condados por orden de <span class="deaths-underline">muertes</span>',
    'Counties ranked by new <span class="new-cases-underline">cases</span>':
      'Condados por orden de nuevos <span class="new-cases-underline">casos</span>',
    'Cumulative totals': 'Totales acumulados',
    'cases per 100k': 'casos por 100k',
    'in last 7 days': 'en los últimos 7 días',
    'March': 'mar',
    'cases': 'casos',
    'Latino': 'Latinos',
    'Asian': 'Asiáticos',
    'Black': 'Negros',
    'White': 'Blancos',
    'Other': 'Otros',
    'Cases by race per 100,000 residents':
      'Casos por grupo étnico por cada 100,000 personas',
    'Deaths by age': 'Muertes (por edad)',
    'Cases Pct.': 'Porcentaje de casos',
    'by race and age': 'por raza y edad',
    'Percentage of <span class="cum-cases-underline">cases</span> vs. <span class="population-underline">population</span>':
      'Porcentaje de <span class="cum-cases-underline">casos</span> frente a <span class="population-underline">población</span',
    'Percentage of <span class="deaths-underline">deaths</span> vs. <span class="population-underline">population</span>':
      'Porcentaje de <span class="deaths-underline">muertes</span> frente a <span class="population-underline">población</span',
    'Cases at <span class="cases-blue">nursing homes</span> vs. <span class="cases-light-blue">elsewhere</span>':
      'Casos en <span class="cases-blue">hogares de ancionos</span> frente a <span class="cases-light-blue">muertes en otros lugares</span>',
    'Deaths at <span class="deaths-gray">nursing homes</span> vs. <span class="deaths-light-gray">elsewhere</span>':
      'Muertes en <span class="deaths-gray">hogares de ancianos</span> frente a <span class="deaths-light-gray">muertes en otros lugares</span>',
    '<span class="active-cases">Active</span> cases':
      'Casos <span class="active-cases">activos</span>',
    '<span class="cases-blue">Active</span> cases':
      'Casos <span class="cases-blue">activos</span>',
    'Cumulative <span class="cumulative-cases">cases</span>':
      '<span class="cumulative-cases">Casos</span> acumulados',
    'Cumulative': 'Acumulados',
    'Active': 'Activos',
    "Active <span class='cases-blue'>cases</span>":
      'Casos <span class="cases-blue">activos</span>',
    'Cumulative <span class="deaths-underline">deaths</span>':
      '<span class="deaths-underline">Muertes</span> acumuladas',
    'Cumulative cases': 'Casos acumulados',
    'Active cases': 'Casos activos',
    'Deaths': 'Muertes',
    'Hover for more information':
      'Mantenga el cursor sobre el mapa para más información',
    'deaths per 100k': 'muertes por 100k',
    'California Department of Corrections and Rehabilitation':
      'Departamento de Correcciones y Rehabilitación de California',
    'Times survey of county and local health departments':
      'Encuesta del Times a los departamentos de salud locales y del condado',
    '<span class="cases-blue">Intensive care</span> and <span class="cases-light-blue">other</span> hospitalized patients':
      '<span class="cases-blue">Cuidados intensivos</span> y <span class="cases-light-blue">otros</span> pacientes hospitalizados',
    'Both': 'Ambos',
    'Positive': 'Confirmados',
    'Suspected': 'Probables',
    'Percentage of Californians who have received <span class="vaccines-light-green">one</span> dose or are <span class="vaccines-green">fully</span> vaccinated':
      'Porcentaje de californianos que han recibido <span class="vaccines-light-green">una dosis</span> o que están <span class="vaccines-light-green">totalmente</span> vacunados',
    'Percentage of Californians who have received <span class="vaccines-light-green">one</span> or <span class="vaccines-green">two</span> doses':
      'Administradas Porcentaje de californianos que han recibido <span class="vaccines-light-green">una</span> o <span class="vaccines-green">dos</span> dosis',
    'Percentage of Californians who are <span class="vaccines-light-green">partially</span> or <span class="vaccines-green">fully</span> vaccinated':
      'Porcentaje de californianos que están <span class="vaccines-light-green">parcial</span> o <span class="vaccines-green">totalmente</span> vacunados',
    '<a href="https://covid.cdc.gov/covid-data-tracker/#vaccinations">Centers for Disease Control and Prevention</a>':
      '<a href="https://covid.cdc.gov/covid-data-tracker/#vaccinations">Centros para el Control y la Prevención de Enfermedades</a>',
    '<a href="https://github.com/CSSEGISandData/COVID-19">Johns Hopkins University CSSE</a>, Times survey':
      '<a href="https://github.com/CSSEGISandData/COVID-19">CSSE de la Universidad Johns Hopkins</a>, encuesta del Times',
    'New deaths in <span class="deaths-darkest-gray">California</span> vs. <span class="deaths-light-gray">the rest</span> of the country':
      'Nuevas muertes en <span class="deaths-darkest-gray">California</span> frente a <span class="deaths-light-gray">al resto</span> del país',
    'New cases in <span class="cases-blue">California</span> vs. <span class="cases-light-blue">the rest</span> of the country':
      'Nuevos casos en <span class="cases-blue">California</span> frente a <span class="cases-light-blue">al resto</span> del país',
    'of Californians are at least partially vaccinated':
      'de californianos están parcialmente vacunados',
    'Omicron': 'Ómicron',
    'Variants among new cases': 'Variantes entre los nuevos casos',
    'Original strain and other variants': 'Cepa original y otras variantes',
    'Due to delays in data collection, totals for the most recent days are incomplete.':
      'Debido a los retrasos en la recolección de datos, los totales de los días más recientes están incompletos.',
    'million': 'millones',
  },
};
